"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const common_styled_components_1 = require("../../../common-styled-components");
const DnvIntegrationTool_1 = __importDefault(require("./DnvIntegrationTool"));
const LrIntegrationTool_1 = __importDefault(require("./LrIntegrationTool"));
const VerifaviaIntegrationTool_1 = __importDefault(require("./VerifaviaIntegrationTool"));
const theme_1 = require("../../../../theme");
const useFetch_1 = __importDefault(require("../../../../hooks/useFetch"));
const YearContext_1 = require("../../../../contexts/YearContext");
const apiUtils_1 = require("../../../../util/apiUtils");
const toolTabs = [
    { id: "verifavia", label: "Verifavia" },
    { id: "dnv", label: "DNV" },
    { id: "lr", label: "LR" },
];
const IntegrationTools = () => {
    const [selectedTab, setSelectedTab] = (0, react_1.useState)("verifavia");
    const { selectedYear } = (0, YearContext_1.useYear)();
    const [overview, _setOverviewUrl, setOverviewBody] = (0, useFetch_1.default)("admin/overview.json", undefined, true);
    (0, react_1.useEffect)(() => {
        setOverviewBody(JSON.stringify({ pool_year: selectedYear }));
    }, [selectedYear, setOverviewBody]);
    const poolOptions = overview.status === apiUtils_1.LoaderStatus.Success
        ? overview.data.pools.map((pool) => ({
            label: pool.name,
            value: pool.id,
        }))
        : [];
    const fleetOptions = overview.status === apiUtils_1.LoaderStatus.Success
        ? overview.data.fleets.map((fleet) => ({
            label: fleet.name,
            value: fleet.id,
        }))
        : [];
    return ((0, jsx_runtime_1.jsxs)(common_styled_components_1.PageContent, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.Navigation, { style: {
                    marginBottom: "24px",
                    borderBottom: `1px solid ${theme_1.theme.colors.darkBlue}`,
                    gap: "0px",
                }, children: toolTabs.map((tab) => ((0, jsx_runtime_1.jsx)(common_styled_components_1.NavigationButton, { selected: selectedTab === tab.id, onClick: () => setSelectedTab(tab.id), children: tab.label }, tab.id))) }), overview.status === apiUtils_1.LoaderStatus.Success && ((0, jsx_runtime_1.jsxs)(common_styled_components_1.ContentGrid, { "$cols": 1, children: [selectedTab === "verifavia" && ((0, jsx_runtime_1.jsx)(VerifaviaIntegrationTool_1.default, { fleetOptions: fleetOptions, poolOptions: poolOptions })), selectedTab === "dnv" && ((0, jsx_runtime_1.jsx)(DnvIntegrationTool_1.default, { fleetOptions: fleetOptions, poolOptions: poolOptions })), selectedTab === "lr" && ((0, jsx_runtime_1.jsx)(LrIntegrationTool_1.default, { fleetOptions: fleetOptions, poolOptions: poolOptions }))] }))] }));
};
exports.default = IntegrationTools;
